<template>
  <Main>
    <template v-slot:toolbar>
      <div class="ghostWhite">
        <fragment v-if="currentCriticism">
          <ToolbarCriticism
            class="max-content-width"
            :quotation="currentCriticism"
            :new-route="newCriticismRoute"
          />
        </fragment>
      </div>
    </template>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        :items="breadcrumb"
        @return="previousPage"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb :items="breadcrumb" @return="previousPage" />
    </template>
    <fragment v-if="show">
      <HeaderCriticism />
      <v-row v-for="(item, key) in currentCriticism.criticas" :key="key">
        <CriticismMessage
          :item="item"
          :index="key"
          @resend="resendCriticism"
          @regularize="openModalRegularize"
          @answer="answerCriticism"
        />
      </v-row>
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="closeModal"
      :title="title"
      :text="text"
    />
    <ModalNewMessageCriticism
      v-model="modalAnswer"
      v-if="modalAnswer"
      @close="closeModalNewMessage"
      @submit="submitNewMessage"
    />
    <ModalRegularizeCriticism
      v-model="modalRegularize"
      @close="closeModalRegularize"
      title="REGULARIZAR CRÍTICA"
      text="Você deseja regularizar a crítica?"
      text-button="SIM"
      has-cancel-button
    />
  </Main>
</template>
<script>
import ToolbarCriticism from "../../quotation/components/ToolbarCriticism";
import CriticismMessage from "../../quotation/components/CriticismMessage";
import { mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import ModalGenericCriticism from "../../quotation/components/ModalGenericCriticism";
import ModalRegularizeCriticism from "../../quotation/components/ModalGenericCriticism";
import HeaderCriticism from "@/components/HeaderCriticism";
import ModalNewMessageCriticism from "../../quotation/components/ModalNewMessageCriticism";
import _ from "lodash";
import PolicyMixin from "@/mixins/PolicyMixin";
export default {
  data: () => ({
    show: false,
    text: null,
    title: null,
    modal: false,
    breadcrumb: [
      {
        text: "Críticas Solicitação de endosso - ",
        to: "quotation element"
      }
    ],
    currentCriticism: null,
    modalAnswer: false,
    answerMessage: null,
    itemRegularize: null,
    modalRegularize: false
  }),
  components: {
    CriticismMessage,
    ToolbarCriticism,
    ModalGenericCriticism,
    HeaderCriticism,
    ModalNewMessageCriticism,
    ModalRegularizeCriticism
  },
  mixins: [LoadingRequest, PolicyMixin],
  created() {
    this.fetchCriticism();
  },
  computed: {
    quotationId() {
      return this.$route.params.id;
    },
    newCriticismRoute() {
      return {
        name: "new criticism endorsement policy",
        params: this.$route.params
      };
    }
  },
  methods: {
    ...mapActions("policy", [
      "requestCriticismEndorsement",
      "requestResolveCriticismEndorsement",
      "requestResendCriticismEndorsement",
      "requestNewCriticismEndorsement"
    ]),
    fetchCriticism() {
      this.withLoading(
        this.requestCriticismEndorsement(this.$route.params).then(response => {
          this.currentCriticism = response;
          this.show = true;
          this.breadcrumb = [
            {
              text: `Críticas Solicitação de endosso - ${response.solicitacao?.numero}`,
              to: "quotation element"
            }
          ];
        })
      );
    },
    resendCriticism(item) {
      this.withLoading(
        this.requestResendCriticismEndorsement(
          this.getPayloadCriticism(item)
        ).then(() => {
          this.modal = true;
          this.title = "MENSAGEM REENVIADA";
          this.text = "Um e-mail foi reenviado para o cliente";
        })
      );
    },
    regularizeCriticism() {
      this.withLoading(
        this.requestResolveCriticismEndorsement(
          this.getPayloadCriticism(this.itemRegularize)
        ).then(() => {
          this.modal = true;
          this.title = "CRÍTICA REGULARIZADA";
          this.text =
            "O status da crítica foi atualizado. Visualize na tela da solicitação de endosso.";
        })
      );
    },
    async submitNewMessage(form) {
      this.closeModalNewMessage();
      this.withLoading(
        this.requestNewCriticismEndorsement(
          await this.getPayloadNewCriticism(form)
        ).then(() => {
          this.modal = true;
          this.title = "NOVA MENSAGEM";
          this.text = "Nova mensagem foi enviada com sucesso.";
        })
      );
    },
    async getPayloadNewCriticism(form) {
      let payload = _.cloneDeep(form);
      payload.documentos = await this.submitFilesWithFormat(form.documentos);
      payload.critica_pai = { id: this.answerMessage.id };
      payload.tipo = _.cloneDeep(this.answerMessage.tipo);
      return {
        id: this.$route.params.id,
        endosso: this.$route.params.endosso,
        payload: payload
      };
    },
    answerCriticism(item) {
      this.modalAnswer = true;
      this.answerMessage = item;
    },
    closeModalNewMessage() {
      this.modalAnswer = false;
    },
    closeModal() {
      this.modal = false;
      this.show = false;
      this.fetchCriticism();
    },
    previousPage() {
      this.$router.push({
        name: "edit endorsement request policy",
        params: this.$route.params
      });
    },
    getPayloadCriticism(item) {
      return {
        id: this.$route.params.id,
        endosso: this.$route.params.endosso,
        critica: item.id
      };
    },
    closeModalRegularize(value) {
      this.modalRegularize = false;
      if (value) {
        this.regularizeCriticism();
      }
    },
    openModalRegularize(item) {
      this.itemRegularize = item;
      this.modalRegularize = true;
    }
  }
};
</script>
